class WuModalv2 {
    constructor(modal) {
        this.modal = modal
        if (this.modal.querySelectorAll(`[data-wu-modal-trigger]`) == null) {
            return false
        } else {
            this.modalTriggers = this.modal.querySelectorAll(`[data-wu-modal-trigger]`)
        }
        if (this.modal.querySelector(`[data-wu-modal-content]`) == null) {
            return false
        } else {
            this.modalContent = this.modal.querySelector(`[data-wu-modal-content]`)
        }
        if (this.modalContent.querySelector('iframe') == null) {
            return false
        } else {
            this.frame = this.modalContent.querySelector('iframe')
        }
        if (this.frame.parentNode == null) {
            return false
        } else {
            this.frameParent = this.frame.parentNode
        }
        this.init()
    }
    init() {
        this.triggerListenerClick()
    }
    triggerListenerClick() {
        for (let i = 0; i < this.modalTriggers.length; i++) {
            this.modalTriggers[i].addEventListener('click', e => {
                this.triggerHandlerClick(e)
            })
        }
    }
    triggerHandlerClick(e) {
        if(this.modal.querySelector('.tabpanel') !== null){
        var element1= this.modal.querySelector('.tabpanel').style.transform;
        var element2= this.modal.querySelector('.tabpanel').style.left;
        if(element1){ var pixel = /\(([^)]*)\)/.exec(element1)[1];}
        else{var pixel = element2;}
        this.modal.querySelector('.tabpanel').removeAttribute("style");
        this.modal.querySelector('.tabpanel').style.cssText =`position:relative;left:${pixel}`;
        }
        this.modalContent.classList.toggle('d-flex')
        this.modalContent.classList.toggle('d-none')
        this.frame.remove()
        this.frameParent.appendChild(this.frame)
    }
}

let allModals = document.querySelectorAll('[data-wu-modal-select]')
if (allModals.length > 0) {
    for (let i = 0; i < allModals.length; i++) {
        new WuModalv2(allModals[i])
    }
}